import { render, staticRenderFns } from "./fourColumnBlock.vue?vue&type=template&id=ebd0d06e&scoped=true&"
import script from "./fourColumnBlock.vue?vue&type=script&lang=js&"
export * from "./fourColumnBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd0d06e",
  null
  
)

export default component.exports